export const TARGET_BLANK = {
    rel: "external noopener noreferrer",
    target: "_blank",
};
//# sourceMappingURL=href.js.map